import { Navigate } from 'react-router-dom';
import AppCache from './services/AppCache'; // adjust path

export default function ProtectedRoute({ children }) {
    const user = AppCache?.GetCurrentLoggedInUser?.();

    // Not logged in → redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
